import React, {Component} from 'react';
import propTypes from "prop-types";
import {connect} from 'react-redux';
import {bindActionCreators, compose} from 'redux';
import * as Actions from '../actions';
import {withRouter} from 'react-router';

//import components
import FooterBottomList from '../components/footer/FooterBottomList.js';
import FooterCredits from '../components/footer/FooterCredits.js';
import MainPageSeparator from '../components/main-page/MainPageSeparator.js';
import FooterSitemap from '../components/footer/FooterSitemap.js';

//helper scripts
import * as wpScripts from '../scripts/wpObjectScripts.js';

class Footer extends Component {
    componentWillMount() {
        const { actions, clang } = this.props;
        actions.getFooterMenu(clang);
        actions.getFooterSitemap(clang);
    };

    componentWillReceiveProps(nextProps) {
        const { actions, clang } = this.props;

        if (clang !== nextProps.clang) {
            actions.getFooterMenu(nextProps.clang);
            actions.getFooterSitemap(nextProps.clang);
        }
    };

    logout = () => {
        const { actions } = this.props;

        actions.logout();
        window.location.reload();
        window.scrollTo(0, 0);
    };

    render() {
        const {footerData, footerSitemapData, currentUser} = this.props;
        const boxes = footerData ? wpScripts.getBoxes(footerData) : [];

        return (
            <footer className="footer">
                <FooterSitemap list={footerSitemapData} user={currentUser} logout={this.logout}/>
                <FooterBottomList list={boxes}/>
                {footerData && <FooterCredits copy={footerData.footer_copyright_text}/>}
                <MainPageSeparator />
            </footer>
        );
    };
};

Footer.propTypes = {
    clang: propTypes.string.isRequired,
    footerData: propTypes.object,
    footerSitemapData: propTypes.arrayOf(propTypes.object),
    actions: propTypes.object.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage,
    footerData: state.mainPage.footerData,
    footerSitemapData: state.mainPage.footerSitemapData,
    currentUser: state.authentication.user,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(Actions, dispatch)
});

const enhance = compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps),
);

export default enhance(Footer);



// WEBPACK FOOTER //
// ./src/containers/Footer.js